// Public base URL of the Mitra One Care PATIENT web app (Frontend-patient-web),
// baked in at build time via VITE_PATIENT_WEB_URL (see the .env.* files).
//
// HISTORY: 2026-08-31 the owner moved patient self-registration to the MOC
// patient portal; 2026-09-02 the owner brought the full form BACK to this
// app's /patient-register — it now creates the common MOC account directly
// (pages/homePage/PatientRegister.jsx), and after registering the person is
// sent to the portal's /#/login to sign in.
//
// Empty when the environment has no patient web deployment — callers hide
// their portal CTAs in that case (the register form then falls back to the
// local /login, whose patient path explains the MOC app).
export const PATIENT_WEB_URL = (import.meta.env.VITE_PATIENT_WEB_URL || '')
  .trim()
  .replace(/\/+$/, '');

// The portal is a HashRouter SPA like this one — its registration page lives
// at /#/register (the same path the backend's "Send Invite" emails use; see
// MOC_PATIENT_APP_URL in Backend/docker-compose.india-saas2.yml).
// An invitation link (?invitationCode=, the tenant app's /patient-register)
// hands its code on, so the portal can fill in and lock the invited e-mail
// (owner, 20 Oct 2026). Nothing else in the query is forwarded.
export const patientRegisterUrl = (search = '') => {
  const code = new URLSearchParams(search).get('invitationCode');
  return `${PATIENT_WEB_URL}/#/register${code ? `?invitationCode=${encodeURIComponent(code)}` : ''}`;
};
